import { BaseNestedFieldDefinition } from '../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../core/profiles/entities/extended-profile-field.entity';

export function VisibleProfileFieldChildren(profileField: ExtendedBaseProfileField): BaseNestedFieldDefinition[] {
    const children: BaseNestedFieldDefinition[] | undefined = profileField.FieldDefinition.Children;
    const childrenToDisplay: string[] | undefined = profileField.ChildrenToDisplay;

    if (!children) {
        return [];
    }

    if (!childrenToDisplay || childrenToDisplay.length === 0) {
        return children;
    }

    return children.filter(child => childrenToDisplay.includes(child.Key));
}
